import { DataGrid, TooltipV2 } from '@cimplico/components';
import { Link } from 'react-router-dom';
import ProviderBadge from '../../components/provider-badge/ProviderBadge';
import { useFirmContext } from '../../providers/FirmProvider';
import { Group } from '../../types/group';
import { formatDateTime, calcRelativeTime } from '../../utilities/formatting';

type GroupRowProps = {
    id: string;
    group: Group;
};

function GroupRow({ id, group }: GroupRowProps): JSX.Element {
    const { shortId } = useFirmContext();
    return (
        <DataGrid.Row id={id}>
            <div className="flex items-center gap-2 py-2">
                <Link to={`/${shortId}/groups/${group.id}`}>
                    <p className="font-medium text-indigo-600 dark:text-indigo-400 text-sm cursor-pointer">{group.name}</p>
                </Link>
            </div>
            <p className="text-sm text-gray-700">{group.entities.length}</p>
            <TooltipV2 message={formatDateTime(group.updatedAt)}>
                <p className="text-gray-700 text-sm">{calcRelativeTime(group.updatedAt)}</p>
            </TooltipV2>
            <p className="text-sm text-gray-700">{group.activeWorkpapers.length}</p>
            <GroupProviderBadges group={group} />
        </DataGrid.Row>
    );
}

type GroupProviderBadgesProps = {
    group: Group;
};

function GroupProviderBadges({ group }: GroupProviderBadgesProps): JSX.Element {
    const integrations = (Object.keys(group.integrations) as Array<keyof typeof group.integrations>).filter(
        (key) => group.integrations[key] !== null
    );

    if (integrations.length === 0) {
        return <div></div>;
    }
    return (
        <div className="flex items-center gap-2">
            <ProviderBadge provider={integrations[0]} />
            {integrations.length > 1 && (
                <TooltipV2 message={integrations.slice(1).map((i) => i.toUpperCase())} position="right">
                    <label className="block mr-1 text-sm text-gray-500 leading-5 font-medium">+{integrations.length - 1}</label>
                </TooltipV2>
            )}
        </div>
    );
}

export default GroupRow;
